// extracted by mini-css-extract-plugin
export default {"wrapper":"Mp","form":"Np","label":"Op","small":"Pp","noMargin":"Qp","success":"Rp","circle":"Sp","successText":"Tp","imageWrapper":"Up","appointment":"Vp"};